import { c as _c } from "react/compiler-runtime";
import { Button } from '@/shared/components/ui';
import type { AvisosDaConversaProps } from '../types';

/** Avisos do cabeçalho do mock do #1333: exportação, histórico paginado e encerramento. */
export const AvisosDaConversa = t0 => {
  const $ = _c(18);
  const {
    exportacao,
    temMaisEventos,
    carregandoEventos,
    erroDosEventos,
    onCarregarMais,
    erroDaExportacao,
    erroDoEncerramento
  } = t0;
  let t1;
  if ($[0] !== exportacao.carregados || $[1] !== exportacao.carregando || $[2] !== exportacao.total) {
    t1 = exportacao.carregando && <p role="status" className="text-caption text-subtext-color mt-3">Preparando conversa: {exportacao.carregados} de {exportacao.total} eventos.</p>;
    $[0] = exportacao.carregados;
    $[1] = exportacao.carregando;
    $[2] = exportacao.total;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== carregandoEventos || $[5] !== erroDosEventos || $[6] !== onCarregarMais || $[7] !== temMaisEventos) {
    t2 = (temMaisEventos || erroDosEventos) && <div className="mt-3 flex items-center gap-3">{erroDosEventos && <p role="alert" className="text-caption text-error-600">Não foi possível atualizar o histórico.</p>}<Button variant="neutral-secondary" size="small" disabled={carregandoEventos} onClick={onCarregarMais}>{erroDosEventos ? "Tentar novamente" : "Carregar mais mensagens"}</Button></div>;
    $[4] = carregandoEventos;
    $[5] = erroDosEventos;
    $[6] = onCarregarMais;
    $[7] = temMaisEventos;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== erroDaExportacao) {
    t3 = erroDaExportacao && <p role="alert" className="text-caption text-error-600 mt-3">{erroDaExportacao}</p>;
    $[9] = erroDaExportacao;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== erroDoEncerramento) {
    t4 = erroDoEncerramento && <p role="alert" className="text-caption text-error-600 mt-3">Não foi possível confirmar o encerramento da simulação anterior. Inicie uma nova simulação para continuar.</p>;
    $[11] = erroDoEncerramento;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <>{t1}{t2}{t3}{t4}</>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};